import { Link } from "react-router-dom";
import { Trash2, Minus, Plus } from "lucide-react";
import { useCart } from "../context/CartContext";
import { imgUrl } from "../lib/api";
import SEO from "../components/SEO";

export default function Cart() {
  const { cart, setQty, removeFromCart, cartTotal } = useCart();

  return (
    <div className="max-w-5xl mx-auto px-4 md:px-8 py-12" data-testid="cart-page">
      <SEO title="Cart" description="Your shopping cart — Humaira Crafts" />
      <h1 className="text-4xl tracking-tighter font-semibold mb-10">Your Cart</h1>

      {cart.length === 0 ? (
        <div className="text-center py-24" data-testid="empty-cart">
          <p className="font-serif text-2xl">Your cart is empty</p>
          <Link to="/shop" className="inline-block mt-6 bg-[#111] text-[#FAF9F6] px-8 py-3 small-caps hover:bg-gold hover:text-[#111] transition-colors duration-300" data-testid="continue-shopping">
            Continue Shopping
          </Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-[1fr_320px] gap-12">
          <div className="flex flex-col divide-y divide-black/10">
            {cart.map(({ product, qty }) => (
              <div key={product.id} className="flex gap-6 py-6" data-testid={`cart-item-${product.slug}`}>
                <Link to={`/product/${product.slug}`} className="w-24 aspect-square border border-black/10 overflow-hidden shrink-0">
                  <img src={imgUrl(product.images?.[0])} alt={product.name} className="w-full h-full object-cover" />
                </Link>
                <div className="flex-1">
                  <p className="small-caps text-muted-foreground">{product.category_name}</p>
                  <Link to={`/product/${product.slug}`} className="font-serif text-lg hover:text-gold transition-colors duration-300">{product.name}</Link>
                  <p className="text-sm mt-1">₹{(product.sale_price || product.price).toLocaleString("en-IN")}</p>
                  <div className="flex items-center justify-between mt-3">
                    <div className="flex items-center border border-black/20">
                      <button onClick={() => setQty(product.id, qty - 1)} className="p-2 hover:text-gold transition-colors duration-300" data-testid={`cart-dec-${product.slug}`} aria-label="Decrease"><Minus strokeWidth={1.5} size={12} /></button>
                      <span className="w-8 text-center text-sm">{qty}</span>
                      <button onClick={() => setQty(product.id, qty + 1)} className="p-2 hover:text-gold transition-colors duration-300" data-testid={`cart-inc-${product.slug}`} aria-label="Increase"><Plus strokeWidth={1.5} size={12} /></button>
                    </div>
                    <button onClick={() => removeFromCart(product.id)} className="text-muted-foreground hover:text-destructive transition-colors duration-300" data-testid={`cart-remove-${product.slug}`} aria-label="Remove">
                      <Trash2 strokeWidth={1.5} size={16} />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="bg-white border border-black/10 p-8 self-start sticky top-32" data-testid="cart-summary">
            <p className="small-caps text-muted-foreground mb-6">Order Summary</p>
            <div className="flex justify-between text-sm py-2"><span>Subtotal</span><span data-testid="cart-subtotal">₹{cartTotal.toLocaleString("en-IN")}</span></div>
            <div className="flex justify-between text-sm py-2 border-b border-black/10 pb-4"><span>Shipping</span><span className="text-muted-foreground text-xs text-right">Calculated at checkout</span></div>
            <div className="flex justify-between font-semibold py-4"><span>Total</span><span data-testid="cart-total">₹{cartTotal.toLocaleString("en-IN")}</span></div>
            <Link to="/checkout" className="block text-center bg-[#111] text-[#FAF9F6] py-4 small-caps hover:bg-gold hover:text-[#111] transition-colors duration-300" data-testid="checkout-button">
              Proceed to Checkout
            </Link>
          </div>
        </div>
      )}
    </div>
  );
}
